module.exports = __webpack_public_path__ + "static/media/21ECLAC14.742779d1.jpg";